/**
 * Theme definitions for presentation exports
 *
 * Colors are in 6-digit hex format WITHOUT the # prefix (pptxgenjs requirement).
 */ const FEDERAL_NAVY_THEME = {
    primary: '0076D6',
    primaryDark: '112F4E',
    secondary: '00BDE3',
    text: '484848',
    textLight: '64748B',
    textOnDark: 'FFFFFF',
    background: 'FFFFFF',
    tableHeader: '112F4E',
    tableRowAlt: 'F8FAFC',
    accentBar: '0076D6'
};
const MODERN_PURPLE_THEME = {
    primary: '7C3AED',
    primaryDark: '4C1D95',
    secondary: 'A78BFA',
    text: '374151',
    textLight: '6B7280',
    textOnDark: 'FFFFFF',
    background: 'FFFFFF',
    tableHeader: '4C1D95',
    tableRowAlt: 'F5F3FF',
    accentBar: '7C3AED'
};
const THEMES = {
    'federal-navy': FEDERAL_NAVY_THEME,
    'modern-purple': MODERN_PURPLE_THEME
};
const DEFAULT_THEME = 'federal-navy';
export function getThemeColors(themeName) {
    return THEMES[themeName] ?? THEMES[DEFAULT_THEME];
}
